import React, { useState, forwardRef, useEffect, useImperativeHandle } from 'react';
import { Modal } from 'react-bootstrap';
import axios from "axios";
import { useNavigate } from "react-router-dom";
import swal from 'sweetalert'; 
import Select from "react-select";

const InviteCustomer = forwardRef((props, ref) => {
  const navigate = useNavigate();
  const [inviteModal, setInviteModal] = useState(false);
  const [data, setData] = useState([]);
  const [company, setCompany] = useState({});
  const [hallData, setHallData] = useState({
    Amount: '',
    ExpenseDate: '',
    ExpenseTypeID: '',
    EmployeeID: '',
    CompanyID: '',
    UserID: '',
  });
  const [errors, setErrors] = useState('');
  
  const userdata = localStorage.getItem('USER_data');
  const userData = JSON.parse(userdata);
  const userid = userData.id;

  // Fetch company data from localStorage
  useEffect(() => {
    const companyData = localStorage.getItem('companies');
    if (companyData) {
      const parsedData = JSON.parse(companyData);
      const singleCompany = Array.isArray(parsedData) ? parsedData[0] : parsedData;
      setCompany(singleCompany); // Set the company data
    }
  }, []);

  // Initialize hallData with company data and user id when company is set
  useEffect(() => {
    if (company.CompanyID && userid) {
      setHallData((prevData) => ({
        ...prevData,
        CompanyID: company.CompanyID,
        UserID: userid,
      }));
    }
  }, [company, userid]);

  // Fetch expense types
  useEffect(() => {
    axios.get('https://suhba.education.com.ly/back/api/fillexpeses')
      .then(({ data }) => {
        setData(data.ExpenseType);
      })
      .catch(function (error) {
        if (error.response) {
          console.error(error.response.data);
        } else if (error.request) {
          console.error(error.request);
        } else {
          console.error('Error', error.message);
        }
      });
  }, []);

  // Show the modal
  useImperativeHandle(ref, () => ({
    showInviteModal() {
      setInviteModal(true);
    }
  }));

  // Handle changes in form fields
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setHallData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  // Handle changes in the Amount field with validation
  const handleInputChange1 = (e) => {
    setErrors('');
    const { name, value } = e.target;

    if (/^\d*$/.test(value)) {
      setHallData((prevData) => ({
        ...prevData,
        [name]: value,
      }));
    } else {
      setErrors("هده الخانه لاتقبل الا الاعداد الصحيحة");
    }
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.post('https://suhba.education.com.ly/back/api/expenses', hallData);
      swal("تمت عملية الحفظ بنجاح");
      setInviteModal(false);
      setHallData({
        Amount: '',
        ExpenseDate: '',
        ExpenseTypeID: '',
        EmployeeID: '',
        CompanyID: company.CompanyID,
        UserID: userid,
      }); // Reset the form fields
    } catch (error) {
      let errorMessage = 'حدث خطأ أثناء حفظ البيانات';
      if (error.response) {
        errorMessage = error.response.data.message || errorMessage;
      }
      swal(errorMessage, '', 'error');
    }
  };

  // Close the modal
  const showInviteModal = () => {
    setInviteModal(false);
  };
const expenseTypeOptions = data.map((row) => ({
  value: row.ExpenseTypeID,
  label: row.TypeName
}));
  return (
    <>
      <Modal className="modal fade" id="exampleModal1" show={inviteModal} centered>
        <div className="modal-content">
          <div className="modal-header">
            <h1 className="modal-title fs-5" id="exampleModalLabel1">إضافة مصروفات الشركة</h1>
            <button type="button" className="btn-close" style={{ marginLeft: 0 }} onClick={() => setInviteModal(false)}></button>
          </div>
          <form onSubmit={handleSubmit}>
            <div className="modal-body">
              <div className="row">
                <div className="col-xl-12">
                  <div className="row">
                    <div className="col-xl-6">
                      <label className="form-label">تاريخ الصرف<span className="text-danger">*</span></label>
                      <div className="input-group">
                        <input 
                          type="date" 
                          className="form-control" 
                          name="ExpenseDate" 
                          value={hallData.ExpenseDate} 
                          onChange={handleInputChange} 
                        />
                      </div>
                    </div>
                    <div className="col-xl-6">
                      <label className="form-label">القيمة<span className="text-danger">*</span></label>
                      <div className="input-group">
                        <input 
                          type="text" 
                          className="form-control" 
                          name="Amount" 
                          value={hallData.Amount} 
                          onChange={handleInputChange1} 
                        />
                      </div>
                      {errors && <div className="alert alert-danger">{errors}</div>}
                    </div>
                  </div>
                  <div className="col-xl-12">
                    <label className="form-label mt-3">دالك لــ<span className="text-danger">*</span></label>
                    <Select
  options={expenseTypeOptions}
  value={expenseTypeOptions.find(
    option => option.value === hallData.ExpenseTypeID
  )}
  onChange={(selected) =>
    handleInputChange({
      target: {
        name: "ExpenseTypeID",
        value: selected ? selected.value : ""
      }
    })
  }
  placeholder="اختر من القائمة"
  isSearchable={true}
/>
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button type="submit" className="btn btn-primary">حفظ</button>
              <button type="button" className="btn btn-danger light" onClick={showInviteModal}>إلغاء</button>
            </div>
          </form>
        </div>
      </Modal>
    </>
  );
});

export default InviteCustomer;
